import { createSlice } from '@reduxjs/toolkit'

export const layoutSlice = createSlice({
  name: 'layout',
  initialState: {
    isMobile: false
  },
  reducers: {
    isMobileStateChanged: (state,action) => {
      return {
        isMobile: action.payload.isMobile
      }
    }
  },
})

// Action creators are generated for each case reducer function
export const { isMobileStateChanged } = layoutSlice.actions

export default layoutSlice.reducer